<div class="overlay" >
  <div id="text" @toggleOverlayAction>
    <div class="overlay-close" (click)="closeOverlay()">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
      <span>{{ 'SHARED.COMPONENT.OVERLAY.CLOSE' | translate }}</span>
    </div>
    <ng-content></ng-content>
  </div>
</div>
